interface BaseSettings{
    configType: string,
    userId: string,
}

export interface NavigationSettings extends BaseSettings {
    debugMode: boolean,
    darkMode: boolean,
    isSideMenuOpen: boolean,
    isSideMenuMobileOpen: boolean,
    storeGroupId: number | null
}



export function setSettings(data: BaseSettings) {
    localStorage.setItem(data.configType + "_" + data.userId, JSON.stringify(data));
}

export function getSettings(configType: string, userId: string): BaseSettings | null {
    try {
        let settingString = localStorage.getItem(configType + "_" + userId) ?? null;
        if (settingString){
            return JSON.parse(settingString) as BaseSettings;
        }
    } catch {
        
    }
    return null;
}